export default "__VITE_ASSET__Z40MVnT9__"